import React, { useEffect, useState } from "react";
import "./PriceTable.scss";

import down from "../../assets/icons/down.svg";
import up from "../../assets/icons/up.svg";
import { getFlagUrl } from "../../utils/getFlagUrl";
import { io } from "socket.io-client";
import { getApiBaseUrl, getSocketPath, apiFetch } from "../../api/client";

const PriceTable = ({ data, type }) => {
  const [loading, setLoading] = useState(true);
  const [bubbleData, setBubbleData] = useState([]);

  const excludedNames = ["یورو مسافرتی", "دلار آمریکا مسافرتی"];

  useEffect(() => {
    // Simulating a fetch request
    const fetchData = async () => {
      setLoading(true); // Start loading
      if (data && data.length !== 0) {
        setLoading(false); // Stop loading after data is "fetched"
      }
    };

    fetchData();
  }, [data]);

  useEffect(() => {
    const baseUrl = getApiBaseUrl();
    if (!baseUrl) return;

    const socket = io(baseUrl, {
      path: getSocketPath(),
      transports: ["polling", "websocket"],
      timeout: 20000,
    });

    socket.on("getTgjuRates", (data) => {
      setBubbleData(data);
    });

    const fetchData = async () => {
      setLoading(true);
      if (type === "tgju") {
        try {
          const res = await apiFetch("/api/tgju-coins", { method: "GET" });
          const json = await res.json();
          setBubbleData(json.tgjuRates ?? []);
        } catch (err) {
          console.error("Error fetching bubble data", err);
        } finally {
          setLoading(false);
        }
      } else {
        if (data && data.length !== 0) {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [data, type]);

  const calculatePercentageChange = (currentPrice, previousPrice) => {
    if (previousPrice === 0) return 0;
    return ((currentPrice - previousPrice) / previousPrice) * 100;
  };

  // ======================
  // Render Bubble Table
  // ======================
  if (type === "tgju") {
    return (
      <div className="price-table-container">
        <table className="price-table">
          <thead>
            <tr>
              <th></th>
              <th>حباب سکه</th>
              <th>قیمت</th>
              <th>تغیرات</th>
              <th>تاریخ بروزرسانی</th>
            </tr>
          </thead>
          <tbody>
            {bubbleData?.map((item, index) => {
              // check if change has + or -
              const changeClass = item.change?.includes("+")
                ? "green"
                : item.change?.includes("-")
                ? "red"
                : "";

              return (
                <tr key={index}>
                  <td className=""></td>
                  <td>
                    <span
                      className={`
            currency-flag
            ${
              item.name === "حباب نیم سکه"
                ? "nim"
                : item.name === "حباب ربع سکه"
                ? "rob"
                : item.name === "حباب سکه گرمی"
                ? "yek"
                : ""
            }
          `}
                    >
                      <img
                        src={
                          item.name === "حباب سکه بهار آزادی"
                            ? require(`../../assets/coins/tamam.png`)
                            : item.name === "حباب سکه امامی"
                            ? require(`../../assets/coins/emami.png`)
                            : require(`../../assets/coins/tamam.png`)
                        }
                        alt={item.name}
                        onError={(e) =>
                          (e.target.src = getFlagUrl("USD"))
                        }
                      />
                    </span>
                    {item["name"]}
                  </td>
                  {/* price divided by 10 and formatted */}
                  <td>{(Number(item["price"]) / 10).toLocaleString()}</td>
                  {/* change with conditional color */}
                  <td className={changeClass}>{item["change"]}</td>
                  <td>
                    {String(item["updateTime"] || "").replace(
                      /\s+00:00:00$/,
                      ""
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {loading && (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="price-table-container">
      <table className="price-table">
        <thead>
          <tr>
            <th></th>
            <th>
              {" "}
              نوع{" "}
              {type === "currency"
                ? "ارز"
                : type === "nimaii"
                ? "ارز نیمایی"
                : "سکه"}
            </th>
            <th>
              خرید{" "}
              {type === "currency"
                ? "ارز"
                : type === "nimaii"
                ? "ارز نیمایی"
                : "سکه"}
            </th>
            <th>
              فروش{" "}
              {type === "currency"
                ? "ارز"
                : type === "nimaii"
                ? "ارز نیمایی"
                : "سکه"}
            </th>
          </tr>
        </thead>
        <tbody>
          {data
            ?.filter((c) => {
              // Exclude items with names in the excludedNames array
              const name =
                type === "currency"
                  ? c.currency.name
                  : type === "nimaii"
                  ? c.nimaii.name
                  : c.coin.name;
              return !excludedNames.includes(name);
            })
            .map((c, index) => (
              <tr key={index}>
                <td className="justify-items-center max-[540px]:w-[1.2rem]">
                  {/* <img className="" src={star} alt="" /> */}
                </td>
                <td className="">
                  <span
                    className={`
                    currency-flag

                      ${
                        type === "coin"
                          ? c.coin.name === "نیم 86"
                            ? "nim"
                            : c.coin.name === "ربع 86 "
                            ? "rob"
                            : c.coin.name === "سکه نیم (قبل ۸۶)"
                            ? "nimB86"
                            : c.coin.name === "سکه ربع (قبل ۸۶)"
                            ? "robB86"
                            : c.coin.name === "سکه یک گرمی"
                            ? "yek"
                            : ""
                          : ""
                      }
                    `}
                  >
                    <img
                      src={
                        type === "currency"
                          ? getFlagUrl(c.currency.symbol)
                          : type === "nimaii"
                          ? getFlagUrl(c.nimaii.symbol)
                          : c.coin.name === "سکه تمام بهار آزادی"
                          ? require(`../../assets/coins/tamam.png`)
                          : c.coin.name === "سکه امامی 86"
                          ? require(`../../assets/coins/emami.png`)
                          : c.coin.name === "سکه امامی (قبل ۸۶)"
                          ? require(`../../assets/coins/emami-B86.png`)
                          : c.coin.name === "سکه نیم (قبل ۸۶)"
                          ? require(`../../assets/coins/tamam-B86.png`)
                          : c.coin.name === "سکه ربع (قبل ۸۶)"
                          ? require(`../../assets/coins/tamam-B86.png`)
                          : require(`../../assets/coins/tamam.png`)
                      }
                      alt={
                        type === "currency"
                          ? c.currency.name
                          : type === "nimaii"
                          ? c.nimaii.name
                          : c.coin.name
                      }
                    />
                  </span>
                  <span className="currency-name">
                    {type === "currency"
                      ? c.currency.name
                      : type === "nimaii"
                      ? c.nimaii.name
                      : c.coin.name}
                  </span>
                </td>
                <td>
                  <div className={`price-value `}>
                    {c.buyPrice.toLocaleString()}
                    <span className="price-icon">
                      {c.buyPrice === c.pBuyPrice ? (
                        "---"
                      ) : (
                        <>
                          <img
                            src={c.buyPrice > c.pBuyPrice ? up : down}
                            alt=""
                          />
                          <span
                            className={`percentage-change text-xs ${
                              c.buyPrice === c.pBuyPrice
                                ? ""
                                : c.buyPrice > c.pBuyPrice
                                ? "green"
                                : "red"
                            }`}
                          >
                            {calculatePercentageChange(
                              c.buyPrice,
                              c.pBuyPrice
                            ).toFixed(2)}
                            %
                          </span>
                        </>
                      )}
                    </span>
                  </div>
                </td>
                <td>
                  <div className={`price-value`}>
                    {c.sellPrice.toLocaleString()}
                    <span className="price-icon">
                      {c.buyPrice === c.pBuyPrice ? (
                        "---"
                      ) : (
                        <>
                          <img
                            src={c.sellPrice > c.pSellPrice ? up : down}
                            alt=""
                          />
                          <span
                            className={`percentage-change text-xs  ${
                              c.buyPrice === c.pBuyPrice
                                ? ""
                                : c.sellPrice > c.pSellPrice
                                ? "green"
                                : "red"
                            }`}
                          >
                            {calculatePercentageChange(
                              c.sellPrice,
                              c.pSellPrice
                            ).toFixed(2)}
                            %
                          </span>
                        </>
                      )}
                    </span>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {loading && (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};

export default PriceTable;
